import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4be9b633"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrap" }

import { ref, Ref } from 'vue'
import { useStore } from 'vuex'
import { getThreeLiabilityList } from '@/apis/insurance'
import { ThreeLiabiltyListItem } from '@/types/insurance'
import { showToastLoading, clearToast, showNormalToast } from '@/utils/tools'

import Header from '@/components/Header.vue'
import ReceiveInsuranceList from './components/receive-insurance-list.vue'
import { commonErrorHandle } from '@/utils/error-handle'


export default /*#__PURE__*/_defineComponent({
  __name: 'receive-insurance-all',
  setup(__props) {

const receiveList: Ref<ThreeLiabiltyListItem[]> = ref([])
const store = useStore()
// 加载已领取数据
async function initReceivedData() {
  showToastLoading()
  try {
    const data = await getThreeLiabilityList({
      user_guid: store?.state?.userInfo?.guid,
    })
    receiveList.value = data
    clearToast()
  } catch (error) {
    commonErrorHandle(error)
    console.log('error', error)
  }
}

initReceivedData()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, { title: "第三者责任险" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ReceiveInsuranceList, { list: receiveList.value }, null, 8, ["list"])
    ])
  ], 64))
}
}

})